import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator' // koristiš sada fleksibilnu komponentu
import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'

const Boks = ({ calculatorType = 'Boks' }) => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
    },
    results: {
      odds: ['', ''],
    },
  })
  const [showInputArea, setShowInputArea] = useState(true)

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const calculateWinningChances = () => {
    const parsedOdds = Array.isArray(data?.values.odds)
      ? data.values.odds.map((odd) => parseFloat(odd)).filter((odd) => odd > 0)
      : []

    if (parsedOdds.length === 0) {
      console.error(
        'Invalid odds provided. Ensure all odds are greater than zero.'
      )
      return
    }

    const percentages = parsedOdds.map((odd) => (1 / odd) * 100)
    const totalPercentage = percentages.reduce((acc, val) => acc + val, 0)
    const excessPercentage = totalPercentage - 100
    const adjustment =
      parsedOdds.length > 0 ? excessPercentage / parsedOdds.length : 0

    const results = percentages.map((percentage) =>
      Math.max(0, parseFloat((percentage - adjustment).toFixed(2)))
    )

    setData((prevData) => ({
      ...prevData,
      results: {
        odds: results,
      },
    }))
  }

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
      },
      results: {
        odds: ['', ''],
      },
    })
    setShowInputArea((prev) => !prev)
  }

  const handleButtonClick = () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    }
    setShowInputArea((prev) => !prev)
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleButtonClick} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>

        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod utakmice
            </div>
            <OddsCalculator
              data={data.values}
              field={'odds'}
              setData={setData}
              calculation={calculateWinningChances}
              labelPrefix={['KI 1', 'KI 2']}
              type={['number', 'number']}
              step={['0.1', '0.1']}
              min={['0.1', '0.1']}
              setError={setError}
              rows={2}
            />
          </>
        )}
        {!showInputArea && (
          <>
            <div className={classesK.sectionResults}>
              <ResultsSection
                title={`Ishod utakmice`}
                subtitle={`Konačan ishod`}
                withPercent={true}
                results={data?.results?.odds.map((result) => `${result}%`)}
                names={['KI 1', 'KI 2']}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Boks
